module.exports = __webpack_public_path__ + "4df408a24af9cd9766e4750656d51786.gif";